import { render, staticRenderFns } from "./DetailPriceDrawWhite.vue?vue&type=template&id=204fa228&scoped=true"
import script from "./DetailPriceDrawWhite.vue?vue&type=script&lang=js"
export * from "./DetailPriceDrawWhite.vue?vue&type=script&lang=js"
import style0 from "./DetailPriceDrawWhite.vue?vue&type=style&index=0&id=204fa228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204fa228",
  null
  
)

export default component.exports